export const exchangeConfig = {
  instant: {
    title: 'Cambio instantáneo',
    defaultCopyKey: 'instantExchange',
    customCopyKey: 'summary.instant_exchange',
  },
  normal: {
    title: 'Cambio',
    defaultCopyKey: 'exchange',
    customCopyKey: 'summary.exchange',
  },
}
